import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthorizationService } from './authorization.service';
import { AuthenticationService } from './authentication.service';
import { Clients } from '@models/security/clients';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AppPermissionGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
    private authenticationService: AuthenticationService
  ) {}

  canActivate() {
    const token = this.authenticationService.getAccessToken();
    if (!token) {
      return false;
    }

    return forkJoin({
      zion: this.authorizationService.getPermissions(Clients.ZION),
      markus: this.authorizationService.getPermissions(Clients.MARKUS),
      ponch: this.authorizationService.getPermissions(Clients.PONCH),
    }).pipe(
      map(({ zion, markus, ponch }) => {
        const hasAnyPermission = zion.length > 0 || markus.length > 0 || ponch.length > 0;
        if (hasAnyPermission) {
          return true;
        }
        return this.router.createUrlTree(['/no-permissions']);
      })
    );
  }
}
